module.exports = __webpack_public_path__ + "static/ISO-9001-2015-06378530d3878b16a1f9f3c307c8f5da.png";